export const LOADER_STATUS = 'boilderplate/Gstr6/Gstr6/LOADER_STATUS';